/**
 * The coding schemes of the uploader's two coded lists
 * (scripts/gen-community-codes.py writes both under these): anatomic sites are
 * SNOMED CT; stains are TileRiver's own codes (TRST001…), a private scheme, so
 * its designator begins with 99 (DICOM PS3.16 §8). The server refuses a site
 * or a stain that is not on its list under its scheme.
 */
export const SITE_SCHEME = 'SCT';
export const STAIN_SCHEME = '99TILERIVER';
